var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-block-comments-overview-wrapper",
    },
    [
      _c(
        "table",
        {
          staticClass: "default",
        },
        [
          _c("caption", [
            _vm._v(
              "\n            " + _vm._s(_vm.$gettext("Blöcke")) + "\n        "
            ),
          ]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c("thead", [
            _c(
              "tr",
              {
                staticClass: "sortable",
              },
              [
                _c(
                  "th",
                  {
                    class: _vm.getSortClass("units"),
                    on: {
                      click: function click($event) {
                        return _vm.sort("units")
                      },
                    },
                  },
                  [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "#",
                        },
                      },
                      [_vm._v(_vm._s(_vm.$gettext("Lernmaterial")))]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "th",
                  {
                    class: _vm.getSortClass("structural-elements"),
                    on: {
                      click: function click($event) {
                        return _vm.sort("structural-elements")
                      },
                    },
                  },
                  [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "#",
                        },
                      },
                      [_vm._v(_vm._s(_vm.$gettext("Seite")))]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "th",
                  {
                    class: _vm.getSortClass("blocks"),
                    on: {
                      click: function click($event) {
                        return _vm.sort("blocks")
                      },
                    },
                  },
                  [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "#",
                        },
                      },
                      [_vm._v(_vm._s(_vm.$gettext("Blocktyp")))]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "th",
                  {
                    staticClass: "responsive-hidden",
                    class: _vm.getSortClass("comments"),
                    on: {
                      click: function click($event) {
                        return _vm.sort("comments")
                      },
                    },
                  },
                  [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "#",
                        },
                      },
                      [_vm._v(_vm._s(_vm.$gettext("Kommentare")))]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "th",
                  {
                    staticClass: "responsive-hidden",
                    class: _vm.getSortClass("feedback"),
                    on: {
                      click: function click($event) {
                        return _vm.sort("feedback")
                      },
                    },
                  },
                  [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "#",
                        },
                      },
                      [_vm._v(_vm._s(_vm.$gettext("Anmerkungen")))]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "th",
                  {
                    staticClass: "actions",
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$gettext("Aktionen")) +
                        "\n                "
                    ),
                  ]
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _vm.filteredBlocks.length > 0
            ? _c(
                "tbody",
                _vm._l(_vm.filteredBlocks, function (block) {
                  return _c(
                    "tr",
                    {
                      key: block.id,
                    },
                    [
                      _c("td", [_vm._v(_vm._s(block.unitName))]),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: block.elementURL,
                            },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(block.element.attributes.title) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(block.attributes.title))]),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "responsive-hidden",
                        },
                        [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "#",
                              },
                              on: {
                                click: function click($event) {
                                  $event.preventDefault()
                                  return _vm.enableCommentsDialog(block)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.$gettextInterpolate(
                                      _vm.$ngettext(
                                        "%{length} Kommentar",
                                        "%{length} Kommentare",
                                        block.comments.length
                                      ),
                                      {
                                        length: block.comments.length,
                                      }
                                    )
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "responsive-hidden",
                        },
                        [
                          block.element.attributes["can-edit"]
                            ? _c(
                                "a",
                                {
                                  attrs: {
                                    href: "#",
                                  },
                                  on: {
                                    click: function click($event) {
                                      $event.preventDefault()
                                      return _vm.enableFeedbackDialog(block)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.$gettextInterpolate(
                                          _vm.$ngettext(
                                            "%{length} Anmerkung",
                                            "%{length} Anmerkungen",
                                            block.feedbacks.length
                                          ),
                                          {
                                            length: block.feedbacks.length,
                                          }
                                        )
                                      ) +
                                      "\n                    "
                                  ),
                                ]
                              )
                            : [
                                _vm._v(
                                  "\n                        -\n                    "
                                ),
                              ],
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "actions",
                        },
                        [
                          _c("studip-action-menu", {
                            attrs: {
                              items: _vm.getMenuItems(block),
                              context: _vm.$gettext("Blöcke"),
                            },
                            on: {
                              showComments: function showComments($event) {
                                return _vm.enableCommentsDialog(block)
                              },
                              showFeedback: function showFeedback($event) {
                                return _vm.enableFeedbackDialog(block)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  )
                }),
                0
              )
            : _c("tbody", [
                _c(
                  "tr",
                  {
                    staticClass: "empty",
                  },
                  [
                    _c(
                      "td",
                      {
                        attrs: {
                          colspan: "6",
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.$gettext(
                                "Es wurden keine Kommentare oder Anmerkungen gefunden"
                              )
                            ) +
                            "\n                "
                        ),
                      ]
                    ),
                  ]
                ),
              ]),
        ]
      ),
      _vm._v(" "),
      _vm.showCommentsDialog
        ? _c("courseware-comments-overview-dialog", {
            attrs: {
              "item-type": "block",
              "com-type": "comment",
              item: _vm.currentDialogBlock,
            },
            on: {
              close: _vm.closeCommentsDialog,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showFeedbackDialog
        ? _c("courseware-comments-overview-dialog", {
            attrs: {
              "item-type": "block",
              "com-type": "feedback",
              item: _vm.currentDialogBlock,
            },
            on: {
              close: _vm.closeFeedbackDialog,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c("colgroup", [
      _c("col", {
        staticStyle: {
          width: "16em",
        },
      }),
      _vm._v(" "),
      _c("col", {
        staticStyle: {
          width: "16em",
        },
      }),
      _vm._v(" "),
      _c("col", {
        staticStyle: {
          width: "8em",
        },
      }),
      _vm._v(" "),
      _c("col", {
        staticClass: "responsive-hidden",
        staticStyle: {
          width: "8em",
        },
      }),
      _vm._v(" "),
      _c("col", {
        staticClass: "responsive-hidden",
        staticStyle: {
          width: "8em",
        },
      }),
      _vm._v(" "),
      _c("col", {
        staticStyle: {
          width: "2em",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }